var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"headline",class:['el-'+_vm.details.id, _vm.advanced.cssClasses, _vm.responsiveClasses],style:(_vm.style),attrs:{"id":_vm.advanced.cssId}},[_c('v-style',[_vm._v(" "+_vm._s(_vm.fontCss)+" ")]),_c('div',{staticClass:"headline-inner",domProps:{"innerHTML":_vm._s(_vm.details.content || '<h3>Default headline item</h3>')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }